<template>
  <section class="px-16">
    <div class="section-content max-w-3xl mx-auto space-y-8">
      <h3 class="uppercase text-center tracking-wider font-light">
        {{ product.name }}
      </h3>

      <template v-if="packageItems.length">
        <div v-if="packageEditions.length" class="space-y-8">
          <div class="w-full">
            <ul class="flex">
              <li
                v-for="packageEdition in packageEditions"
                :key="packageEdition.id"
                class="flex-1 px-1"
              >
                <PackageEditionRadioButton
                  :package-edition="packageEdition"
                  :checked="selectedEditionId === packageEdition.id"
                  :base-price="+product.price"
                  @click="setEdition(packageEdition.id)"
                />
              </li>
            </ul>
          </div>
        </div>

        <div class="space-y-8">
          <div class="border border-gray-400 rounded-lg overflow-hidden">
            <div class="h-2 border-b border-gray-400 bg-white" />

            <div class="flex-1 bg-white">
              <div class="list list--nested">
                <div class="list__header flex flex-col leading-normal px-6 py-2">
                  <div class="flex items-baseline">
                    <div class="flex-1">
                      {{ product.name }}
                    </div>
                    <div class="w-32 pl-4 uppercase text-right font-semibold">
                      {{ product.price }} euro
                    </div>
                  </div>
                </div>
                <!--
                  List Body
                -->
                <div class="list__body">
                  <!--
                    List Item
                  -->
                  <OrderItem
                    v-for="(item, index) in items"
                    :key="item.id"
                    :item="
                      entityById('packageItems', item.upgradedWith ? item.upgradedWith : item.id)
                    "
                    :selected="item.selected"
                    @add="updateItemProp(index, 'selected', true)"
                    @remove="updateItemProp(index, 'selected', false)"
                    @upgrade="updateItemProp(index, 'upgradedWith', $event)"
                    @downgrade="updateItemProp(index, 'upgradedWith', null)"
                  />
                </div>
                <!--
                  Total
                -->
                <div class="list__footer flex flex-col leading-normal px-6 py-4 font-semibold">
                  <div class="flex items-baseline -mx-4 justify-end">
                    <div class="flex-none text-gray-600 capitalize text-sm">τελική τιμή</div>
                    <div class="flex-none px-4 text-right">
                      <div class="uppercase font-semibold tracking-wider text-gray-900">
                        {{ totalPrice }} euro
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <div class="flex space-x-4 justify-end px-2">
        <button
          v-if="packageItems.length"
          class="btn btn-brand style-link"
          @click="setEdition(null)"
        >
          <span class="uppercase">εκκαθαριση</span>
        </button>
        <button class="btn btn-brand" @click="doCreateOrderAndProceedToReview">
          <span class="uppercase">παραγγελια</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { entityComputed } from '@/store/helper';
import OrderItem from './sectionOrder/OrderItem.vue';
import PackageEditionRadioButton from './sectionOrder/PackageEditionRadioButton.vue';

export default {
  name: 'SectionOrder',
  components: {
    OrderItem,
    PackageEditionRadioButton,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    packageItems: {
      type: Array,
      default: () => [],
    },
    packageEditions: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedEditionId: null,
    items: [
      // {
      //   id: 'package-item-id',
      //   optional: 'true or false',
      //   selected: 'true or false',
      //   upgradedWith: 'package-item-id',
      // },
    ],
  }),
  computed: {
    ...entityComputed,
    selectedEdition() {
      if (!this.selectedEditionId) return null;
      return this.packageEditions.find(
        (packageEdition) => packageEdition.id === this.selectedEditionId
      );
    },
    cart() {
      return [
        {
          name: this.product.name,
          quantity: 1,
          pricePerUnit: this.product.price,
          productUuid: this.product.id,
          requirements: this.product.requirements,
        },
        ...this.items
          .filter((item) => item.selected)
          .map((item) => {
            const packageItem = this.packageItems.find(
              (o) => o.id === (item.upgradedWith || item.id)
            );

            return {
              name: packageItem.name,
              quantity: 1,
              pricePerUnit: packageItem.price,
              productUuid: packageItem.productId,
              requirements: packageItem.requirements,
            };
          }),
      ];
    },
    totalPrice() {
      return this.cart.reduce((acc, cur) => acc + cur.quantity * cur.pricePerUnit, 0);
    },
  },
  created() {
    this.items = this.packageItems
      .filter((packageItem) => packageItem.upgradesPackageItemId === null)
      .sort((a, b) => (a.optional < b.optional ? -1 : 1))
      .map(({ id, optional }) => ({
        id,
        optional,
        selected: !optional,
        upgradedWith: null,
      }));
  },
  methods: {
    setEdition(editionId) {
      this.selectedEditionId = editionId;
      const { packageItems = [] } = this.selectedEdition || {};
      this.items.forEach((item, index) => {
        if (item.optional) {
          this.items[index].selected = packageItems.indexOf(item.id) !== -1;
        }
        this.items[index].upgradedWith = null;
      });
    },
    updateItemProp(index, key, value) {
      if (!this.items[index] && Object.keys(this.items[index]).indexOf(key) === -1) return;
      const item = { ...this.items[index] };
      item[key] = value;
      this.$set(this.items, index, item);
      if (key === 'selected') this.selectedEditionId = null;
    },
    doCreateOrderAndProceedToReview() {
      window.localStorage.setItem('order_name', this.product.name);
      window.localStorage.setItem('cart', JSON.stringify(this.cart));
      this.$router.push({
        name: 'accounts.orders.create',
        params: { ...this.$route.params },
      });
    },
  },
};
</script>
